<template>
  <v-card flat class="conteneurLead">
    <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
      <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
      <span class="title">Occupation conseiller {{nameAgentComputed}}</span>
      <v-spacer></v-spacer>
    </v-card-title>

    <v-card-text>
      <p>Temps de référence pour la période du {{dateStartComputed}} au {{dateEndComputed}} est de <strong>{{afficheTotalTempsRef}}</strong></p>
      <v-flex xs12>
        <v-card class="mb-3" height="400px" v-if="loading">
          <v-card-text class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card v-if="!loading" class="mb-3" >
          
          <!-- <v-layout row>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              flat
              @click="exportAgentsChatsPie()"
            >
              exporter en csv
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
          </v-layout> -->
          <v-flex d-flex xs12>
            <v-layout row wrap>

                <v-flex xs12 md3 class="text-md-center">
                  <highcharts :options="productivityAgent"></highcharts>
                  <span>{{ $t('connectionRate')}} : {{tauxProductivity1}} % ({{afficheTotalTempsConnexion}})</span><br />
                  <span>{{ $t('agentsActivity')}} : {{tauxProductivity2}} % ({{afficheTotalTempsPresence}})</span><br />
                  <span>{{ $t('agentsInactivity')}} : {{tauxProductivity3}} % ({{afficheTotalTempsHorsProd}})</span><br />
                </v-flex>
                <v-flex xs12 md3 class="text-md-center">
                  <highcharts :options="activityAgent"></highcharts>
                  <span>Temps d'activité : {{afficheTotalTempsPresence}}</span><br />
                  <span>{{ $t('maximumOccupancy')}} : {{afficheTotalTempsBusy}}</span><br />
                  <!-- <p class="text-md-center">Temps total en activité partielle : {{afficheTotalTempsPartielleActivity}}</p> -->
                  <span>{{ $t('partialOccupation')}} : {{afficheTotalTempsPartielleChat}}</span><br />
                </v-flex>
                <v-flex xs12 md6 class="text-md-center">
                  <highcharts :options="tauxActivityAgent"></highcharts>
                </v-flex>

            </v-layout>
          </v-flex>
          <v-flex d-flex xs12>
            <v-layout row wrap>
                <v-flex xs12 md4 class="text-md-center">
                  <span class="text-md-center">Temps cumulé en chat : {{afficheTotalTempsChat}}</span>
                </v-flex>
                <v-flex xs12 md3 class="text-md-center">
                  <span class="text-md-center">Moyenne limite chatMax : {{moyenChatMax}}</span>
                </v-flex>
                <v-flex xs12 md3 class="text-md-center">
                  <span class="text-md-center">Temps total moyen en chat : {{afficheTotalTempsMoyenChats}}</span>
                </v-flex>
            </v-layout>
          </v-flex>
        </v-card>
      </v-flex>
    </v-card-text>

  </v-card>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
// import momentTz from 'moment-timezone'
import 'moment-duration-format'
import { mapGetters } from 'vuex'
import json2csv from 'json2csv'

export default {
  props: {
    dataAgentSelected: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      // chats par agent
      loading: false,
      utcDecal: '',
      tempsPresence: 28800, // 8 heures
      joursPresence: 5, // jours travaillés par semaine
      totalJoursOuvres: 1, // nombre de jours travaille sur la période
      totalTempsConnexion: 0,
      totalTempsPresence: 0,
      totalTempsAllChats: 0, // temps total de chat
      tempsTotalOnline: 0, // temps total online en econdes
      tempsTotalBusy: 0, // temps total busy en secondes
      tempsOccupationBusy: 0, // pour confirmer si les chiffres collent
      moyenChatMax: 0, // moyen des chats max sur la durrée (au cas ou elle change en cours de durrée)
      tempsOccupationPartielle: 0, // occupation partielle, agent online en chat mais pas fullChat
      totalTempsChat: [0, 0, 0, 0],
      moyenChatHeure: [],
      joursPeriode: 0,
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,
      // options générales pour les graphiques
      optionsGraph: {
        chart: {
        },
        colors: [
          '#F44336', // red
          '#3F51B5', // indigo
          '#009688', // teal
          '#E91E63', // pink
          '#607D8B', // blue-grey
          '#9C27B0', // purple
          '#2196F3', // blue
          '#FF5722', // deep-orange
          '#795548', // brown
          '#4CAF50', // green
          '#8BC34A', // light-green
          '#673AB7', // deep-purple
          '#CDDC39', // lime
          '#03A9F4', // light-blue
          '#FFC107', // amber
          '#FF9800', // orange
          '#FFEB3B', // yellow
          '#00BCD4', // cyan
          '#9E9E9E'  // grey
        ],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      // graphique activité
      // camembert
      productivityAgent: {
        chart: {
          type: 'solidgauge',
          height: '300px',
          events: {
            // render: this.renderGraph()
          }
        },

        title: {
          text: _.upperFirst(this.$t('productivity'))
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div><div style="font-size:0.7em; text-align: center; width:100%">{series.name}</div><br><div style="font-size:1.5em; color: {point.color}; font-weight: bold; text-align: center; width:100%">{point.y}%</div></div>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: (this.chart.plotHeight / 2) + 15
            }
          }
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
            outerRadius: '112%',
            innerRadius: '88%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#3F51B5')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Exercise
            outerRadius: '87%',
            innerRadius: '63%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#8BC34A')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Stand
            outerRadius: '62%',
            innerRadius: '38%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#9E9E9E')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: _.upperFirst(this.$t('connected')),
          data: [{
            color: '#3F51B5',
            // color: this.Highcharts.getOptions().colors[0],
            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: _.upperFirst(this.$t('emojiActivity')),
          data: [{
            color: '#8BC34A',
            // color: this.Highcharts.getOptions().colors[1],
            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: _.upperFirst(this.$t('inactivity')),
          data: [{
            color: '#9E9E9E',
            // color: this.Highcharts.getOptions().colors[2],
            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      },

      // graphique activité
      // camembert
      activityAgent: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: 300,
          type: 'pie'
        },
        title: {
          text: _.upperFirst(this.$t('advisorOccupancy'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {
// ------------------------------------------------------------------------
// momentanement commenté pour ne pas avoir acces au stats
                click: (e) => {
                //   this.openOccupation(e)
                  // console.log('date', this.category)
                  // console.log('id agent', this.series.userOptions.agentID)
                }
// ------------------------------------------------------------------------
              }
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      },

      tauxActivityAgent: {
        chart: {
        },
        title: {
          text: 'Taux d\'occupation du conseiller'
        },
        subtitle: {
          text: 'Occupation moyenne par heure dans une journée'
        },
        xAxis: {
          categories: ['00 h', '01 h', '02 h', '03 h', '04 h', '05 h', '06 h', '07 h', '08 h', '09 h', '10 h', '11 h', '12 h', '13 h', '14 h', '15 h', '16 h', '17 h', '18 h', '19 h', '20 h', '21 h', '22 h', '23 h'],
          title: {
            text: 'Heures'
          }
        },
        yAxis: [
          {
            min: 0,
            max: 100,
            title: {
              text: 'Taux d\'occupation'
            },
            labels: {
              formatter: function () {
                return this.value + ' %'
              }
            }
          },
          {
            min: 0,
            title: {
              text: 'Solicitations visiteurs',
              style: {
                color: this.Highcharts.getOptions().colors[0]
              }
            },
            labels: {
              // formatter: function () {
              //   return this.value + ' Solicitations visiteurs'
              // }
              format: '{value} ',
              style: {
                color: this.Highcharts.getOptions().colors[0]
              }
            },
            opposite: true
          }
        ],
        tooltip: {
          split: true,
          // shared: true,
          valueSuffix: ' %'
        },
        plotOptions: {
          // column: {
          //   stacking: 'normal'
          // }
          area: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          },
          line: {
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 4
              }
            },
            marker: {
              enabled: false
            }
          }
        },
        series: []
      }
    }
  },

  created () {
    // console.log('created vue')
    // console.log('Date.UTC(2010, 0, 1, 0, 0, 0)', Date.UTC(2010, 0, 1, 0, 0, 0))
    // console.log('this.dataAgentSelected.dateStart', this.dataAgentSelected.dateStart)
    // console.log('this.dataAgentSelected.dateEnd', this.dataAgentSelected.dateEnd)
    this.joursPeriode = Math.round((((this.dataAgentSelected.dateEnd - this.dataAgentSelected.dateStart) / 60) / 60) / 24)
    // total de jours travaillés sur la période
    if (this.joursPeriode < 7) {
      if (this.joursPeriode > this.dataAgentSelected.joursHebdo) {
        this.totalJoursOuvres = this.dataAgentSelected.joursHebdo
      } else {
        this.totalJoursOuvres = this.joursPeriode
      }
    } else {
      this.totalJoursOuvres = (this.joursPeriode / 7) * this.dataAgentSelected.joursHebdo
    }

    // heures travaillés par jour
    this.tempsPresence = ((this.dataAgentSelected.tempsTravail * 60) * 60) // heures en secondes
    // console.log('tempsPresence', this.dataAgentSelected)
    // console.log('totalJoursOuvres', (this.joursPeriode / 7))
    // affichage des loaders
    // this.loadingAgentsChats = true
    // this.loadingAgentsActivity = true
    // initialisation des options liées aux graphiques
    // this.agentOccupation = _.merge(this.agentOccupation, this.optionsGraph)
    // this.agentConnexions = _.merge(this.agentConnexions, this.optionsGraph)
    // this.agentStatus = _.merge(this.agentStatus, this.optionsGraph)
    this.productivityAgent = _.merge(this.productivityAgent, this.optionsGraph)
    this.activityAgent = _.merge(this.activityAgent, this.optionsGraph)
    this.tauxActivityAgent = _.merge(this.tauxActivityAgent, this.optionsGraph)
    // this.getAll()
    // const _self = this
    this.tempsPresence = ((this.dataAgentSelected.tempsTravail * 60) * 60) // heures en secondes
    console.log('tempsPresence', this.dataAgentSelected)
  },

  mounted () {
    this.loading = true
    let dateNow = Date.now()
    let inverseOffset = moment(dateNow).utcOffset()
    // console.log('inverseOffset', inverseOffset)
    this.utcDecal = inverseOffset
    // console.log('mounted vue')
    // console.log('dataAgentSelected', this.dataAgentSelected)
    this.getOccupation()
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    agentsChatsPieComputed () {
      let res = []
      _.each(this.agentOccupation.series[0].data, a => {
        let name = a.name.split(' (')[0]
        let chats = a.name.split(' (')[1].split(' ')[0]
        res.push({
          name: name,
          y: a.y,
          chats: chats
        })
      })
      return res
    },
    dataAgentComputed () {
      return this.dataAgentSelected
    },
    nameAgentComputed () {
      return this.dataAgentSelected.agentName
    },
    dateStartComputed () {
      return moment.parseZone((this.dataAgentSelected.dateStart * 1000)).format('LL')
    },
    dateEndComputed () {
      return moment.parseZone((this.dataAgentSelected.dateEnd * 1000)).format('LL')
    },
    // affiche le temps total connecté au bo
    afficheTotalTempsConnexion () {
      return moment.duration((this.totalTempsConnexion / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps total full chat
    afficheTotalTempsBusy () {
      return moment.duration((this.tempsTotalBusy / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps total en activité
    // afficheTotalTempsActivity () {
    //   // temps online + occupé
    //   let tempsActivity = (this.tempsTotalBusy + this.tempsTotalOnline)
    //   return moment.duration((tempsActivity / 60), 'minutes').format('h [h] m [min]')
    // },
    // affiche le temps total en activité partiel
    afficheTotalTempsPartielleActivity () {
      return moment.duration((this.tempsTotalOnline / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps myen en chat
    // la moyen de chatMax est calculé sur la période selectionnée
    // (il est possible que l'agent change ce nombre de chatMax en cours de période)
    afficheTotalTempsMoyenChats () {
      let tempsChatMoyen = (this.totalTempsAllChats / this.moyenChatMax)
      return moment.duration((tempsChatMoyen / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps total en chat
    afficheTotalTempsChat () {
      let tempsChatMoyen = this.totalTempsAllChats
      return moment.duration((tempsChatMoyen / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps hors production
    afficheTotalTempsHorsProd () {
      let tempsHorsProd = (this.totalTempsConnexion - (this.tempsTotalBusy + this.tempsTotalOnline))
      return moment.duration((tempsHorsProd / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps partielle en chat
    afficheTotalTempsPartielleChat () {
      let tempsChatPartielle = this.tempsOccupationPartielle
      return moment.duration((tempsChatPartielle / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps de presence agent (online + busy)
    afficheTotalTempsPresence () {
      let tempsPresence = this.totalTempsPresence
      return moment.duration((tempsPresence / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps busy 2 pour confirmation
    afficheTotalTempsBusyChat () {
      let tempsChatBusy = this.tempsTotalBusy
      return moment.duration((tempsChatBusy / 60), 'minutes').format('h [h] m [min]')
    },
    // Calcule le taux d'occupation busy
    // temps de presence agent uniquement busy
    tauxBusy () {
      return (this.tempsTotalBusy * 100) / this.totalTempsConnexion
    },
    // Calcule le taux d'occupation partirel, 1chat mini et pas au max des chat
    // le temps de presence agent uniquement si en chat et pas busy
    tauxOccupationPartiel () {
      return (this.tempsOccupationPartielle * 100) / this.totalTempsConnexion
    },
    // Calcule le taux d'inoccupation pas en chat et online
    // le temps de presence agent (online + busy) - (temps partiel en chat + temps busy)
    tauxInoccupation () {
      let inoccuper = this.totalTempsPresence - (this.tempsTotalBusy + this.tempsOccupationPartielle)
      // let inoccuper = (this.totalTempsConnexion - (this.tempsOccupationPartielle + this.tempsOccupationBusy))
      return ((inoccuper) * 100) / this.totalTempsConnexion
    },
    // affiche le temps de reference pour la période
    afficheTotalTempsRef () {
      // tempsPresence: dataAgentSelected.tempsTravail, // 8 heures
      // joursPresence: dataAgentSelected.joursHebdo, // jours travaillés par semaine
      let tempsRef = 0
      if (this.joursPeriode < 7) {
        if (this.joursPeriode > this.joursPresence) {
          tempsRef = (this.tempsPresence * this.joursPresence)
        } else {
          tempsRef = (this.tempsPresence * this.joursPeriode)
        }
      } else {
        tempsRef = (this.tempsPresence * this.joursPresence) * (this.joursPeriode / 7)
      }
      return moment.duration((tempsRef / 60), 'minutes').format('h [h] m [min]')
    }
  },

  methods: {
    getOccupation () {
      // console.log('dataAgentSelected', this.dataAgentSelected)
      this.tempsPresence = ((this.dataAgentSelected.tempsTravail * 60) * 60) // heures en secondes
      this.joursPresence = this.dataAgentSelected.joursHebdo // jours travaillés par semaine
      // this.agentOccupation.series.push({'data': []})
      let param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) +
        '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) +
        '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID)
      this.axios.get('get/occupationAgentPeriode.php?' + param)
      .then(response => {
        // console.log('response', response)
        this.totalTempsAllChats = response.data.totalTempsAllChats // en secondes
        this.tempsOccupationPartielle = response.data.tempsOccupationPartielle // en secondes
        this.tempsOccupationBusy = response.data.tempsOccupationBusy // en secondes
        this.moyenChatMax = response.data.moyenChatMax
        this.moyenChatHeure = response.data.chatParHeure
      })
      .catch()
      .then(_ => {
        // this.loading = false
        this.getConnexions()
        // this.occupationAgentDay = true
      })
    },

    /**
     * lance toutes les requêtes
     */
    getConnexions () {
      // this.agentConnexions.series.push({'data': []})
      let param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) +
        '&refTime=' + encodeURIComponent(this.tempsPresence) +
        '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) +
        '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID)
      this.axios.get('get/connexionAgentPeriode.php?' + param)
      .then(response => {
        // console.log('response : ', response)
        this.totalTempsConnexion = response.data.totalTempsConnexion
      })
      .catch()
      .then(_ => {
        // this.loading = false
        // this.occupationAgentDay = true
        // charge les status agent
        this.getStatusAgent()
      })
    },

    /**
     * lance la requête statusAgentDay
     */
    getStatusAgent () {
    //   this.agentStatus.series.push({'data': []})
      let param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) +
        '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) +
        '&agentsId=' + encodeURIComponent(this.dataAgentSelected.agentID)
      this.axios.get('get/statusAgentPeriode.php?' + param)
      .then(response => {
        // console.log('response : ', response)
        this.totalTempsPresence = response.data.totalTempsPresence // en seconde
        this.tempsTotalOnline = response.data.tempsTotalOnline // en secondes
        this.tempsTotalBusy = response.data.tempsTotalBusy // en secondes
        // console.log('tempsTotalOnline', this.tempsTotalOnline)
        // console.log('tempsTotalBusy', this.tempsTotalBusy)
        let dataOccupation = [
          {
            name: _.upperFirst(this.$t('partialOccupation')),
            color: this.optionsGraph.colors[9],
            y: this.tauxOccupationPartiel
          },
          {
            name: _.upperFirst(this.$t('maximumOccupancy')),
            color: this.optionsGraph.colors[15],
            y: this.tauxBusy
          },
          {
            name: _.upperFirst(this.$t('unoccupied')),
            color: this.optionsGraph.colors[10],
            y: this.tauxInoccupation
          }
        ]
        // console.log('dataOccupation', dataOccupation)
        this.activityAgent.series = [{}]
        this.activityAgent.series[0].data = []
        // this.activityAgent.series[0].data[0] = dataOccupation
        this.activityAgent.series[0].data = dataOccupation

        // données pour les taux d'occupation agent
        let dataTauxOccupation = [
          {
            type: 'area',
            name: _.upperFirst(this.$t('offline')),
            color: this.optionsGraph.colors[0],
            data: response.data.arrayTauxOffline,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ' %'
            }
          },
          {
            type: 'area',
            name: _.upperFirst(this.$t('online')),
            color: this.optionsGraph.colors[10],
            data: response.data.arrayTauxOnline,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ' %'
            }
          },
          {
            type: 'area',
            name: _.upperFirst(this.$t('busy')),
            color: this.optionsGraph.colors[15],
            data: response.data.arrayTauxBusy,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ' %'
            }
          },
          {
            yAxis: 1,
            name: _.upperFirst('Solicitations visiteurs'),
            color: this.optionsGraph.colors[4],
            data: this.moyenChatHeure,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ''
            }
          }
        ]
        this.tauxActivityAgent.series = dataTauxOccupation
        // console.log('this.tauxActivityAgent.series[0]', this.tauxActivityAgent.series[0])
      })
      .catch()
      .then(_ => {
        this.loading = false
        // this.occupationAgentDay = true
        // charge les status agent
        // this.getStatusAGent()
        // calcule l'activité en poucentage
        // % de presence / (par le nombre de jours de la période selectionnée)
        // console.log('this.totalTempsConnexion', this.totalTempsConnexion)
        // console.log('this.tempsPresence', this.dataAgentSelected.tempsTravail)
        // console.log('joursPeriode', this.joursPeriode)
        // console.log('this.tempsTotalBusy', this.tempsTotalBusy)
        // console.log('this.tempsTotalOnline', this.tempsTotalOnline)
        // console.log('afficheTotalTempsActivity', this.afficheTotalTempsActivity)
        // temps total online + busy
        let totalActivityTime = (this.tempsTotalBusy + this.tempsTotalOnline)
        // console.log('totalActivityTime', totalActivityTime)
        // console.log('this.totalJoursOuvres', this.dataAgentSelected.joursHebdo)
        let tempsRef = 0
        if (this.joursPeriode < 7) {
          if (this.joursPeriode > this.joursPresence) {
            tempsRef = (this.tempsPresence * this.joursPresence)
          } else {
            tempsRef = (this.tempsPresence * this.joursPeriode)
          }
        } else {
          tempsRef = (this.tempsPresence * this.joursPresence) * (this.joursPeriode / 7)
        }

        let presence = (this.totalTempsConnexion * 100) / tempsRef
        this.tauxProductivity1 = presence.toFixed(2)
        this.productivityAgent.series[0].data[0].y = Math.round(presence * 100) / 100
        // console.log('presence', presence)
        // % d'activité chat
        // il faut diviser ce nombre par le nombre de chat max dispo pour cet agent
        // console.log('totalActivityTime', totalActivityTime)
        let totalChats = (totalActivityTime * 100) / tempsRef
        this.tauxProductivity2 = totalChats.toFixed(2)
        this.productivityAgent.series[1].data[0].y = Math.round(totalChats * 100) / 100
        // % d'inactivité
        let inactiv = ((this.totalTempsConnexion - totalActivityTime) * 100) / tempsRef
        this.tauxProductivity3 = inactiv.toFixed(2)
        this.productivityAgent.series[2].data[0].y = Math.round(inactiv * 100) / 100
        // console.log('this.productivityAgent', totalActivityTime + '-' + this.totalTempsAllChats)
      })
    },

    /**
     * lance toutes les requêtes
     */
    getAll () {
      this.getAgentsChats()
    },

    /**
     * Close dialogue occupation
     */
    cancelDialog () {
      // this.dialogEdit = false
      this.$emit('closeDialog')
    },

    /**
     * Ouvre l'occupation d'un agent à la journée selectionné
     */
    openDayOccupation (data) {
      // console.log('data user : ', data)
      // console.log('date (category) : ', data.point.category)
      // console.log('agent id : ', data.point.series.userOptions.agentID)
      // console.log('agent name : ', data.point.series.userOptions.name)
      let indexDate = data.point.index
      // console.log('date : ', data.point.series.userOptions.day[indexDate])
      // console.log('date seleted ', data.point.series.userOptions.arrayDays[indexDate].date)
      let dateStart = moment.parseZone(data.point.series.userOptions.arrayDays[indexDate].date).format('X')
      let dateEnd = dateStart + 86400
      let agentID = data.point.series.userOptions.agentID
      this.dataAgentSelected.dateStart = dateStart
      this.dataAgentSelected.dateEnd = dateEnd
      this.dataAgentSelected.agentID = agentID

      // console.log('dateStart : ', dateStart)
      // let param = 'dateStart=' + encodeURIComponent(dateStart) +
      //   '&dateEnd=' + encodeURIComponent(dateEnd) +
      //   '&agentId=' + encodeURIComponent(agentID)
      // this.axios.get('get/occupationAgentDay.php?' + param)
      // .then(response => {
      //   console.log('response : ', response)
      // })
      // .catch()
      // .then(_ => {
      //   this.loadingAgentsChats = false
      //   this.occupationAgentDay = true
      // })
    },

    /**
     * Récupère les chats par agents
     */
    getAgentsChats () {
      this.loadingAgentsChats = true
      this.axios.get('get/agents_chats.php?' + this.params)
      .then(response => {
        // mise à jour du graphique avec les données récupérées
        // reset des data du graphique
        this.agentsChatsPie.series = [{}]
        this.agentsChatsPie.series[0].data = []
        this.agentsChatsBar.series = []
        this.agentsChatsBar.xAxis.categories = []
        // Maj du camembert (part des chats/agent)
        // et ajout des series pour les agents du graph colonnes
        let idAgents = []
        let nbChats = 0
        response.data.chatsByAgent.forEach(agent => {
          // change l'id par le nom de l'agent parmis les agents sélectionné
          let agentFound = _.find(this.$store.state._User.colleagues, {'USR_ID': _.toString(agent.id)})
          this.agentsChatsPie.series[0].data.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME + ' (' + agent.nb + ' chats)',
            y: agent.pourcent
          })
          // incrémentation du nombre de chat totaux
          nbChats += agent.nb
          idAgents.push(agent.id)
          this.agentsChatsBar.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            data: []
          })
        })
        // Maj du titre indiquant le total de chats
        this.agentsChatsPie.title.text = _.upperFirst(this.$tc('distributionOfChats', 1, {count: nbChats}))
        // Maj des colonnes stackées (data par jour)
        // pour chaque jour
        Object.entries(response.data.days).forEach(([date, agents]) => {
          // ajout des jours dans l'axe des X
          this.agentsChatsBar.xAxis.categories.push(moment(date).format('ll'))
          // ajout des données dans l'axe des Y
          // pour chaque agent
          Object.entries(agents).forEach(([id, chat]) => {
            let idx = idAgents.findIndex(i => i === _.toNumber(id))
            if (idx !== -1 && this.agentsChatsBar.series[idx]) {
              this.agentsChatsBar.series[idx].data.push(chat)
            }
          })
        })
        // console.log('this.agentsChatsBar', this.agentsChatsBar)
      })
      .catch()
      .then(_ => {
        this.loadingAgentsChats = false
      })
    },

    exportAgentsChatsPie () {
      let csv = ''
      let data = []
      let fields = []
      let fieldNames = ['agent', 'chats', 'pourcentage']
      fields = ['name', 'chats', 'y']
      data = this.agentsChatsPieComputed
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsChatsPie.csv', csv)
    },

    downloadFile (filename, content) {
      let hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content)
      hiddenElement.target = '_blank'
      hiddenElement.download = filename
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzAgentsOccupationPeriode.vue